import {toIcon} from "./icon.shared";

export const arrowSquare = toIcon(
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 5.25L10.5 8.75H3.5L7 5.25Z" fill="#868686"/>
  </svg>,
);
